import { render, staticRenderFns } from "./addTast.vue?vue&type=template&id=38077076&scoped=true&"
import script from "./addTast.vue?vue&type=script&lang=js&"
export * from "./addTast.vue?vue&type=script&lang=js&"
import style0 from "./addTast.vue?vue&type=style&index=0&id=38077076&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38077076",
  null
  
)

export default component.exports